import LandAction from './LandAction.container'
export default LandAction
